if(!customElements.get('hero-section')) {

  class HeroSection extends HTMLElement {

    constructor() {
      super();
      this.handleGoToNextSection();
    }

    /**
     * handleGoToNextSection
     */
    handleGoToNextSection () {
      // Go to next section slide
      const heroGoToNextSectionButtons = this.querySelectorAll('[data-hero-go-to-next-section]');
      heroGoToNextSectionButtons.forEach(button => {
        button.addEventListener('click', function(){
          const currentSection = button.closest('.shopify-section');
          const nextSection = currentSection.nextElementSibling;
          if(nextSection != null) {
            nextSection.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
          }
        });
      });
    }

  }

  window.HeroSection = HeroSection;

  customElements.define('hero-section', HeroSection);

}